const STORAGE_KEY = 'analytics_opted_out';

// An account's opt-out is only known while it is signed in. Remembering it on
// the device lets the logged-out shell (a public registration link opened
// after signing out) honour it too. Storage can be unavailable; the opt-out
// then holds only while signed in.
export function rememberOptOut(optedOut: boolean): void {
	try {
		if (optedOut) {
			localStorage.setItem(STORAGE_KEY, '1');
		} else {
			localStorage.removeItem(STORAGE_KEY);
		}
	} catch {
		// see above
	}
}

export function hasRememberedOptOut(): boolean {
	try {
		return localStorage.getItem(STORAGE_KEY) === '1';
	} catch {
		return false;
	}
}
